import { AmplifyConfigure } from '@loggi/authentication-lib';
import config from '../aws-exports';

AmplifyConfigure(config);
